import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AutoLogin = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('token');

        if (token) {
            try {
                // simple jwt parsing to get payload
                const base64Url = token.split('.')[1];
                const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));

                const decodedUser = JSON.parse(jsonPayload);

                // Assuming user payload is directly inside, or mapping it correctly
                // In vendorController, login payload is { userId, userName, roleId, email, phone }
                // So we wrap it in a structure that frontend expects if needed, or just store the decoded user.
                const userInfo = {
                    id: decodedUser.userId,
                    name: decodedUser.userName,
                    email: decodedUser.email,
                    role_id: decodedUser.roleId,
                    phone: decodedUser.phone,
                    is_verified: true
                };

                localStorage.setItem('authToken', token);
                localStorage.setItem('userInfo', JSON.stringify(userInfo));
                
                // Redirect to dashboard
                navigate('/admin/dashboard');
            } catch (error) {
                console.error("Invalid token:", error);
                navigate('/login');
            }
        } else {
            navigate('/login');
        }
    }, [location, navigate]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f0f2f5' }}>
            <div style={{ textAlign: 'center' }}>
                <i className="fas fa-spinner fa-spin" style={{ fontSize: '3rem', color: '#007bff' }}></i>
                <h4 className="mt-3" style={{fontFamily: 'Poppins, sans-serif'}}>Logging you in securely...</h4>
            </div>
        </div>
    );
};

export default AutoLogin;
